module.exports = __webpack_public_path__ + "static/media/riocolorado.17a77c5f.jpg";